import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/matapelajaran";
var post = "/matapelajaran";
export const actGetDataMatapelajaran = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_MATAPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_MATAPELAJARAN",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_MATAPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_MATAPELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataMatapelajaran = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_MATAPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Subjects has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_MATAPELAJARAN", open: false })
          );
          return dispatch(actGetDataMatapelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_MATAPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_MATAPELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataMatapelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_MATAPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Subjects has been updated");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_MATAPELAJARAN", open: false })
          );
          return dispatch(actGetDataMatapelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_MATAPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_MATAPELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataMatapelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_MATAPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_MATAPELAJARAN",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_MATAPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_MATAPELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataMatapelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_MATAPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Subject has been deleted");
          return dispatch(actGetDataMatapelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_MATAPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_MATAPELAJARAN",
          message: "Network error..",
        });
      });
  };
};
